import moment from "moment";

import { ResidualsUserRole } from "globalConstants";
import { hasPermissions, agentPermissionSet, permissionList } from "helpers";


export const getPaidMonthYearFromSearchParameters = (
	search: string,
): { paidMonth: string; paidYear: string } => {
	const searchParams = new URLSearchParams(search);
	const paidMonth = searchParams.get("paid_month");
	const paidYear = searchParams.get("paid_year");

	if (!paidMonth || !paidYear) {
		const currentYear = moment().year();
		const currentMonth = moment().month() + 1;

		return {
			paidMonth: currentMonth.toString(),
			paidYear: currentYear.toString(),
		};
	}

	return { paidMonth, paidYear };
};

export const getPaidDateFromSearchParameters = (
	search,
	paidMonthValue = "paidMonth",
) => {
	const searchParams = new URLSearchParams(search);
	const paidMonth = moment(searchParams.get("paid_month")).format("MMMM");
	const paidYear = searchParams.get("paid_year");

	const paidData = `${paidMonth} ${paidYear}`;

	if (!paidMonth || !paidYear) {
		return { [paidMonthValue]: moment().format("MMMM YYYY") };
	}

	return { [paidMonthValue]: paidData };
};

export const canViewResiduals = (primaryAgentId, companyId) => {
	const currentUser = JSON.parse(localStorage?.getItem("user") ?? "");
	//Agents without "PrimaryAgentViewResidualsDetailsForTheirAccounts" permission
	//should not see Residuals details where they are the primary agent
	const isCurrentUserIsPrimaryAgent = currentUser?.user_id === primaryAgentId;
	if (isCurrentUserIsPrimaryAgent) {
		return hasPermissions(
			permissionList.PrimaryAgentViewResidualsDetailsForTheirAccounts,
		);
	}

	//Agent should not see Residuals details for the same Agent Office
	//without "ViewScheduleAsResidualSplitProfilesOfAgentOffice" permission
	const isSameAgentOffice = currentUser?.company_id === companyId;
	if (isSameAgentOffice) {
		return hasPermissions(
			permissionList.ViewScheduleAsResidualSplitProfilesOfAgentOffice,
		);
	}

	//Agent should not see Residuals details for downstream
	//without "ViewScheduleAsResidualSplitProfilesDownstream" permission
	return hasPermissions(
		permissionList.ViewScheduleAsResidualSplitProfilesDownstream,
	);
};

export const getSplitProfileUrl = (agentId, splitProfileId, companyId) => {
	if (!agentId || !splitProfileId || !companyId) return "";

	return hasPermissions(agentPermissionSet) &&
		canViewResiduals(agentId, companyId)
		? `/system-setup/agent-setup/edit-agent/${agentId}/residuals-split-profiles/view/${splitProfileId}`
		: "";
};

export const getScheduleAUrl = (agentId, scheduleAId, companyId) => {
	if (!agentId || !scheduleAId || !companyId) return "";

	return hasPermissions(agentPermissionSet) &&
		canViewResiduals(agentId, companyId)
		? `/system-setup/agent-setup/edit-agent/${agentId}/schedule-a/${scheduleAId}/view`
		: "";
};

export const getResidualsRole = roleName => {
	return roleName === ResidualsUserRole;
};
